import { allEnumValues, FulfillmentMethod, UserRight } from '@biteinc/enums';
import { SyncableMenuModelSchema } from './syncable_menu_model_schema.js';
export const menuStructureSchema = {
    displayName: 'menu',
    type: 'object',
    fields: {
        ...SyncableMenuModelSchema.fields,
        name: {
            type: 'shortString',
            required: true,
        },
        internalName: {
            type: 'shortString',
            displayName: 'Internal Name',
            isReadOnly: true,
            isHidden: true,
            tooltip: {
                text: 'A name used only to identify this section internally. Not seen by guests.',
            },
            writeRight: UserRight.ManageMenu,
        },
        posName: {
            type: 'shortString',
            displayName: 'POS Name',
            isReadOnly: true,
            tooltip: {
                text: 'This is the default display name. The field “Display Name” will replace this name on the kiosk.',
            },
        },
        posInternalName: {
            type: 'keyString',
            isReadOnly: true,
            isHidden: true,
        },
        menuCoverId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
        },
        menuTimingId: {
            type: 'mongoId',
            isHidden: true,
            isNullable: true,
        },
        fulfillmentMethods: {
            type: 'array',
            elementType: 'int',
            required: true,
            elementValues: allEnumValues(FulfillmentMethod),
            displayName: 'Dining Options',
            ui: 'table',
            placeholder: 'Select a dining option to add',
            emptyListWarningHtml: 'Please select at least one enabled dining option for this menu to be displayed.',
            isHidden: true,
            writeRight: UserRight.ManageMenu,
        },
        quiz: {
            type: 'object',
            displayName: 'Menu Quiz',
            fields: {
                headerScrimImage: {
                    displayName: 'Header Scrim Image',
                    type: 'array',
                    elementType: 'object',
                    elementSubtype: 'Image',
                    elementUniqueIdFieldName: 'origUrl',
                    required: true,
                    isNullable: true,
                    writeRight: UserRight.ManageMenu,
                    keepAspectRatio: 'contain',
                    size: {
                        width: 900,
                        height: 400,
                    },
                    canHaveLocalizationOverrides: true,
                },
                quizIds: {
                    placeholder: 'Select a quiz to add',
                    type: 'array',
                    displayName: 'Quizzes for location filter questionnaire',
                    elementType: 'mongoId',
                    ui: 'table',
                    writeRight: UserRight.BiteOps,
                },
            },
            // Quizzes require bite support right
            biteOnly: true,
        },
        pages: {
            type: 'array',
            elementType: 'object',
            elementSubtype: 'MenuPage',
            required: true,
            isHidden: true,
            writeRight: UserRight.ManageMenu,
        },
    },
};
//# sourceMappingURL=menu_structure_schema.js.map